import { render } from "./mPayment.vue?vue&type=template&id=9bcbaf78&scoped=true"
import script from "./mPayment.vue?vue&type=script&lang=js"
export * from "./mPayment.vue?vue&type=script&lang=js"

import "./mPayment.vue?vue&type=style&index=0&id=9bcbaf78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcbaf78"]])

export default __exports__